import React from "react";
import PropTypes from "prop-types";
import {FaSolidIcon} from "../../FontAwesomeIcons";
import {WaitingListItemObject} from "./WaitingListItemObject";

export class WaitingListViewItem extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isExpanded: false
        }
        this.times = [];
        for(let i = 0; i <= 23; i++){
            this.times.push(`${("0"+i).slice(-2)}:00`)
        }
    }

    handleInputChange = e => {
        this.props.waitingList[e.target.name] = e.target.value;
        this.props.onChange(this.props.waitingList);
    }

    render() {
        return (
            <React.Fragment>
                <div className={"row mb-2"}>
                    <div className={"col-5 pr-1"}>
                        <input type={"date"} name={"date"} className={"form-control form-control-sm"}
                               onChange={this.handleInputChange} value={this.props.waitingList.date}/>
                    </div>
                    <div className={"col-7"}>
                        <div className={"input-group input-group-sm"}>
                            <select className={"form-control form-control-sm"} name={"start_time"} onChange={this.handleInputChange}  value={this.props.waitingList.start_time}>
                                {this.times.map((t, i) => <option key={i} value={t}>{t}</option>)}
                            </select>
                            <div className={"input-group-append"}>
                                <span className={"input-group-text"}>-</span>
                            </div>
                            <select className={"form-control form-control-sm"} name={"end_time"} onChange={this.handleInputChange}  value={this.props.waitingList.end_time}>
                                {this.times.map((t, i) => <option key={i} value={t}
                                                                  disabled={t <= this.props.waitingList.start_time}>{t}</option>)}
                            </select>
                            <div className={"input-group-append"}>
                                <button className={"btn btn-sm text-danger"} onClick={this.props.onDelete}>
                                    <FaSolidIcon name={"trash"}/>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }

}

WaitingListViewItem.propTypes = {
    waitingList: PropTypes.instanceOf(WaitingListItemObject),
    onChange: PropTypes.func,
    onDelete: PropTypes.func,
}
